import { ProcessorDetails } from '@/lib/api/processors';
import { ProcessorHeader } from '../components/processor-header';
import { ProcessorOverviewCard } from '../components/processor-overview-card';
import { ProcessorMetricsCard } from '../components/processor-metrics-card';
import { NgeniusConfigurationCard } from './components/ngenius-configuration-card';

interface NgeniusProcessorDetailsPageProps {
  processor: ProcessorDetails;
}

export const NgeniusProcessorDetailsPage = ({ processor }: NgeniusProcessorDetailsPageProps) => {
  return (
    <>
      <ProcessorHeader type="ngenius" processor={processor} />
      <ProcessorOverviewCard processor={processor} />
      <ProcessorMetricsCard processor={processor} />
      <NgeniusConfigurationCard processor={processor} />
    </>
  );
};
